import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../../../../app.reducers';
import { getSelectedPropertyName, getSelectedFiscalYear } from '../../../property/property-store/property.selectors';
import { Router } from '@angular/router';
import { getUserRole } from '../../../../shared/auth/redux/auth.selectors';
import { FiscalYear } from 'app/internal/shared/models';
import { SubSink } from 'subsink';

@Component({
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false
})
export class PropertyDashboardComponent implements OnInit, OnDestroy {
  private userRole$: Observable<string>;
  public propertyName$: Observable<string>;
  selectedFiscalYear$: Observable<FiscalYear>;

  private subs = new SubSink();

  constructor(private store: Store<AppState>,
    private router: Router) {

    this.userRole$ = this.store.pipe(select(getUserRole));
    this.propertyName$ = this.store.pipe(select(getSelectedPropertyName));
    this.selectedFiscalYear$ = this.store.pipe(select(getSelectedFiscalYear));
  }

  ngOnInit() {
    // If the user is a Vendor, redirect to the Component page
    this.subs.sink = this.userRole$
      .subscribe((userRole) => {
        if (userRole == null) {
          return;
        }

        if (userRole === 'Vendor') {
          this.router.navigate(['/useraccount/components']);
        }
      });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
